module.exports = __webpack_public_path__ + "media/images/emblems/Avers_wappen-adf148501bd6c676dcf59ecabd27c879.svg";